import { configureStore, combineReducers } from "@reduxjs/toolkit"
import authReducer from "./authSlice"
import crmSalesUnitReducer from './crm/salesUnitSlice'
import organizationEmployeeReducer from "./organization/employeeSlice"
import organizationDepartmentReducer from "./organization/departmentSlice"
import organizationSiteReducer from "./organization/siteSlice"
import organizationPositionGroupReducer from "./organization/positionGroupSlice"
import crmContactReducer from './crm/contactSlice'
import crmCustomerReducer from './crm/customerSlice'
import crmAddressReducer from './crm/addressSlice'
import notificationReducer from './notificationSlice'
import authorizationUserReducer from './authorization/userSlice'
import sessionDashboardReducer from './authorization/sessionDashboardSlice';
import authorizationPermissionReducer from './authorization/permissionSlice'
import authorizationRoleReducer from './authorization/roleSlice'
import authorizationFeatureFlagReducer from './authorization/featureFlagSlice'
import adminDocumentExtractionReducer from './document/extractionAdminSlice'
import bookingSettingCarReducer from './booking/car/carSlice'
import bookingDriverReducer from './booking/car/driverSlice'
import bookingCarReducer from "./booking/car/carBookingSlice"
import bookingSettingExpenseReducer from "./booking/travel/setting/expenseSlice"
import bookingSettingApprovalFlowReducer from "./booking/travel/setting/approvalFlowSlice"
import bookingTravelReducer from './booking/travel/travelBookingSlice'
import bookingDashboardReducer from './booking/dashboardSlice'
import bookingCalendarReducer from './booking/calendarSlice'
import bookingDashboardCarReducer from './booking/dashboard/carSlice'
import bookingDashboardTravelReducer from './booking/dashboard/travelSlice'
import profileUserReducer from './profileUserSlice'
import crmProjectReducer from './crm/projectSlice'
import crmCompetitorReducer from './crm/competiorSlice'
import crmSettingReducer from './crm/settingSlice'
import crmProjectQuotationReducer from './crm/project/quotationSlice'
import crmProjectPifReducer from './crm/project/pifSlice'
import crmWaiverReducer from './crm/project/waiverSlice'
import erpPaymentRequestReducer from './erp/paymentRequestSlice'
import erpPurchaseRequestReducer from './erp/purchaseRequestSlice'
import erpPurchaseOrderReducer from './erp/purchaseOrderSlice'
import crmProjectEnterJobReducer from './crm/project/enterJobSlice'
import crmProjectJobBuildingReducer from "./crm/project/jobBuildingSlice"
import crmReportContractReducer from "./crm/report/contractSlice"
import crmProjectExecutionReducer from "./crm/project/executionSlice"
import crmChangeOrderReducer from "./crm/project/changeOrderSlice"
import crmReportMasterScheduleReducer from "./crm/report/masterScheduleSlice"
import crmReportChangeOrderReducer from "./crm/report/changeOrderSlice"
import crmLeadReducer from "./crm/leadSlice"
import documentationFaqReducer from "./documentation/faqSlice"
import documentationChangeLogReducer from "./documentation/changeLogSlice"
import changelogEntryReducer from "./documentation/changelogEntrySlice"
import userGuideReducer from "./documentation/userGuideSlice"
import docViewReducer from "./documentation/docViewSlice"
import settingsReducer from "./settingsSlice"
import crmReportPcvReducer from "./crm/report/pcvSlice"
import crmReportDashboardReducer from "./crm/report/crmDasboardSlice"
import integrationApplicationReducer from "./integration/applicationSlice"
import driveReducer from "./drive/driveSlice"
import templatePoliciesReducer from "./templatePoliciesSlice"
import socialFeedReducer from "./social/feedSlice"
import crmProjectWarrantyReducer from './crm/project/warrantySlice'
import crmChangeOrderRevisionReducer from './crm/project/changeOrderRevisionSlice'
import crmEngineeringAdviceReducer from './crm/project/engineeringAdviceSlice'
import crmShipmentPackingList from "./crm/shipment/packingListSlice";
import crmShipmentPlan from "./crm/shipment/shipmentPlanSlice";
import crmLogisticTracking, { stripTrackingRows } from "./crm/logistic/logisticTrackingSlice";
import crmShipmentOrderIntake from "./crm/shipment/orderIntakeSlice";
import crmProjectSchedulePMDReducer from "./crm/project/scheduleSlice";
import crmProjectPaymentScheduleReducer from './crm/project/paymentScheduleSlice';
import projectShipmentReducer        from './crm/project/projectShipmentSlice';
import crmProjectPartnerReducer from "./crm/project/partnerSlice";
import crmProjectSpecReducer from "./crm/project/specSlice";
import crmReportReducer from './crm/report/reportSlice';
import requestUserAccountReducer from './request/userAccountSlice';
import requestTerminalAccountReducer from './request/terminalAccountSlice';
import projectInteractionReducer from "./crm/project/interactionSlice";
import stageDiscussionReducer        from "./crm/project/stageDiscussionSlice";
import projectActivityReducer        from "./crm/project/projectActivitySlice";
import recipientActivityReducer    from "./crm/recipientActivitySlice";
import proposalSubmissionReducer     from "./crm/project/proposalSubmissionSlice";
import projectPriceMatrixReducer from "./crm/project/priceMatrixSlice";
import crmReleaseForecastReducer from "./crm/releaseForecastSlice";
import csdMonthlyReducer from "./crm/csdMonthlySlice";
import appSettingsReducer from "./appSettingsSlice";
import dashboardChangeOrderReducer from "./crm/dashboard/changeOrderSlice";
import dashboardSalesReducer from "./crm/dashboard/salesSlice";
import dashboardContractsReducer from "./crm/dashboard/contractSlice";
import dashboardWaiverReducer from "./crm/dashboard/waiverSlice";
import dashboardQuotationReducer from "./crm/dashboard/quotationSlice";
import dashboardJobEntryReducer from "./crm/dashboard/jobEntrySlice";
import dashboardCrmOverviewReducer from "./crm/dashboard/overviewSlice";
import myCalendarReducer from "./my/calendarSlice";
import myInboxReducer    from "./my/inboxSlice";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
  createTransform,
} from "redux-persist";
//import storage from "redux-persist/lib/storage";
import localforage from 'localforage';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';

const persistConfig = {
  key: "root",
  version: 1,
  storage: localforage,
  stateReconciler: autoMergeLevel2,
  // OAuth client rows carry `secret` — the whole credential /oauth/token checks.
  // Persisting them would leave every registered integration's credential in
  // IndexedDB on a shared machine, surviving sign-out until APP_VERSION bumps.
  // Both Integration screens fetch on mount, so nothing is lost by dropping it.
  blacklist: ["integration_application"],
  // Logistic Tracking rows are never stored (filters and paging are): on both
  // save and load, so rows already sitting in IndexedDB are dropped as well.
  transforms: [
    createTransform(stripTrackingRows, stripTrackingRows, { whitelist: ["crm_logistic_tracking"] }),
  ],
};

const rootReducer = combineReducers({ 
  auth: authReducer,
  profile_user: profileUserReducer,
  notification: notificationReducer,
  settings: settingsReducer,
  integration_application: integrationApplicationReducer,
  drive: driveReducer,
  template_policies: templatePoliciesReducer,
  social_feed: socialFeedReducer,

  organization_employee: organizationEmployeeReducer,
  organization_department: organizationDepartmentReducer,
  organization_site: organizationSiteReducer,
  organization_position_group: organizationPositionGroupReducer,
  
  booking_setting_car: bookingSettingCarReducer,
  booking_setting_driver: bookingDriverReducer,
  booking_setting_expense: bookingSettingExpenseReducer,
  booking_setting_approval_flow: bookingSettingApprovalFlowReducer,
  booking_car: bookingCarReducer,
  booking_travel: bookingTravelReducer,
  booking_dashboard: bookingDashboardReducer,
  booking_calendar:  bookingCalendarReducer,
  booking_dashboard_car: bookingDashboardCarReducer,
  booking_dashboard_travel: bookingDashboardTravelReducer,

  crm_setting: crmSettingReducer,
  crm_competitor: crmCompetitorReducer,
  crm_sales_unit: crmSalesUnitReducer,
  crm_contact: crmContactReducer,
  crm_customer: crmCustomerReducer,
  crm_address: crmAddressReducer,
  crm_lead: crmLeadReducer,
  crm_project: crmProjectReducer,
  crm_waiver: crmWaiverReducer,
  erp_payment_request: erpPaymentRequestReducer,
  erp_purchase_request: erpPurchaseRequestReducer,
  erp_purchase_order: erpPurchaseOrderReducer,
  // Phải đăng ký: trang detail journal đọc state qua useSelector. (erp_item /
  // erp_period / erp_inventory KHÔNG đăng ký vì các màn đó chỉ dispatch().unwrap()
  // qua useAgGrid.)
  crm_project_quotation: crmProjectQuotationReducer,
  crm_project_enter_job: crmProjectEnterJobReducer,
  crm_project_job_building: crmProjectJobBuildingReducer,
  crm_project_execution: crmProjectExecutionReducer,
  crm_project_pif: crmProjectPifReducer,
  crm_change_order: crmChangeOrderReducer,
  crm_change_order_revision: crmChangeOrderRevisionReducer,
  crm_engineering_advice: crmEngineeringAdviceReducer,
  crm_warranty: crmProjectWarrantyReducer,
  crm_project_schedule_pmd: crmProjectSchedulePMDReducer,
  crm_project_payment_schedule: crmProjectPaymentScheduleReducer,
  project_shipment:         projectShipmentReducer,
  crm_project_partner: crmProjectPartnerReducer,
  crm_project_spec: crmProjectSpecReducer,
  crm_project_activity:       projectActivityReducer,
  crm_recipient_activity:     recipientActivityReducer,
  crm_project_interaction:    projectInteractionReducer,
  crm_project_price_matrix:   projectPriceMatrixReducer,
  crm_stage_discussion:       stageDiscussionReducer,
  crm_proposal_submission:    proposalSubmissionReducer,

  crm_report: crmReportReducer,
  
  crm_report_contract: crmReportContractReducer,
  crm_report_master_schedule: crmReportMasterScheduleReducer,
  crm_report_change_order: crmReportChangeOrderReducer,
  crm_report_pcv: crmReportPcvReducer,
  crm_report_dashboard: crmReportDashboardReducer,

  crm_shipment_packing_list: crmShipmentPackingList,
  crm_shipment_plan: crmShipmentPlan,
  crm_shipment_order_intake: crmShipmentOrderIntake,

  crm_logistic_tracking: crmLogisticTracking,
  crm_release_forecast: crmReleaseForecastReducer,
  app_settings: appSettingsReducer,
  crm_dashboard_change_order: dashboardChangeOrderReducer,
  crm_dashboard_sales: dashboardSalesReducer,
  crm_dashboard_contracts: dashboardContractsReducer,
  crm_dashboard_waiver: dashboardWaiverReducer,
  crm_dashboard_quotation: dashboardQuotationReducer,
  crm_dashboard_job_entry: dashboardJobEntryReducer,
  crm_dashboard_crm_overview: dashboardCrmOverviewReducer,
  csdMonthly: csdMonthlyReducer,

  my_calendar: myCalendarReducer,
  my_inbox:    myInboxReducer,

  authorization_user: authorizationUserReducer,
  authorization_session_dashboard: sessionDashboardReducer,
  authorization_permission: authorizationPermissionReducer,
  authorization_role: authorizationRoleReducer,
  authorization_feature_flag: authorizationFeatureFlagReducer,
  admin_document_extraction: adminDocumentExtractionReducer,
  
  documentation_faq: documentationFaqReducer,
  documentation_change_log: documentationChangeLogReducer,
  changelog_entry: changelogEntryReducer,
  user_guide: userGuideReducer,
  doc_view: docViewReducer,
  request_user_account: requestUserAccountReducer,
  request_terminal_account: requestTerminalAccountReducer,
  
  //erp_item: itemReducer
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store)